"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryList = void 0;
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const alert_1 = require("client/components/ui/alert");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Search_1 = require("material-ui-icons/Search");
const Button_1 = require("material-ui/Button");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
const manage_group_1 = require("./components/manage-group");
require("./inventory-list.less");
const core_1 = require("@material-ui/core");
const material_ui_icons_1 = require("material-ui-icons");
const material_ui_1 = require("material-ui");
const columns = [
    // {
    //   label: " ",
    //   id: "placeholder",
    //   className: "placeholder"
    // },
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "Name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "dosage"
    },
    {
        label: "qty 2 run",
        id: "qty"
    },
    {
        label: "priority",
        id: "priority"
    }
];
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["Empty"] = "Invalid: group name cannot be empty";
    ErrorMessage["Duplicate"] = "Invalid: no duplicates allow";
    ErrorMessage["Invalid"] = "Invalid: character must be [A-Z, 0-9, _, -]";
})(ErrorMessage || (ErrorMessage = {}));
let InventoryList = class InventoryList extends react_1.Component {
    // C-046.2
    constructor(props) {
        super(props);
        this.loading = false;
        this.checkedParents = {};
        this.checkedBoxes = {};
        this.order = "ASC";
        this.orderBy = "priority";
        this.showChildren = {};
        this.confirmDelete = null;
        this.showMenu = {};
        this.filterText = "";
        this.groupText = "";
        this.groupToBeRemoved = null;
        this.manageGroupMode = false;
        this.manageDisabledNDC = false; // E-003 TMPP > Formulary - Option to Hide Unchecked NDC's
        this.invalidGroupText = false;
        this.errorMessage = "";
        this.showGroupEditModal = false;
        this.groupTitleEditMode = false;
        this.groupTextEditing = "";
        this.editqty2run = false;
        this.editqty2runId = null;
        this.newQuantityToRun = {};
        this.showGroupRemoveConfirmation = false;
        this.showConfirmationGroupManagementSave = false;
        this.siteId = 0;
        this.inStock = [];
        this.isNDC = false; // C-046.2
        // C-046.2
        this.handleClick = (e) => {
            this.setState({ anchorEl: e.currentTarget });
        };
        this.handleClickAway = (e) => {
            this.setState({ anchorEl: null });
        };
        // C-046.11
        this.showDisableNDC = async () => {
            this.isNDC = !this.isNDC;
            if (this.isNDC) {
                this.loadDisableNDCInventories();
            }
            else {
                await this.loadInventories();
            }
        };
        this.loadInventories = throttle_debounce_1.debounce(200, async () => {
            this.loading = true;
            this.inStock = [];
            await store_1.inventoryListStore.loadInventory({
                // count: 100,
                count: null,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                where: ""
                // where: this.siteId
                //   ? `inventorysite.siteId = ${
                //       this.siteId
                //     } AND inventorysite.active = true`
                //   : "" // Only filter active flag if viewing site view.
            });
            this.loading = false;
        });
        // C-046.11
        this.loadDisableNDCInventories = throttle_debounce_1.debounce(200, async () => {
            this.loading = true;
            this.inStock = [];
            await store_1.inventoryListStore.loadInventory({
                // count: 100,
                count: null,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                where: "",
                showDeleted: true
            });
            this.loading = false;
        });
        this.loadInventoriesPriorityAscending = async () => {
            this.order = "ASC";
            this.orderBy = "priority";
            this.loadInventories();
        };
        this.onCallback = async (value) => {
            this.filterText = value;
            await this.loadInventories();
        };
        this.resetGroupText = () => {
            this.groupText = "";
        };
        this.getGetOrdinal = (n) => {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        };
        this.canAddGroupName = () => {
            if (!this.groupText) {
                this.errorMessage = ErrorMessage.Empty;
                this.invalidGroupText = true;
                return false;
            }
            const groupListFromDB = store_1.inventoryListStore.inventoryGroups.value || [];
            if (groupListFromDB.length) {
                const isDuplicate = groupListFromDB.some((group) => group.group === this.groupText);
                if (isDuplicate) {
                    this.errorMessage = ErrorMessage.Duplicate;
                    this.invalidGroupText = true;
                    return false;
                }
            }
            // Can contain a-z A-Z spaces mininum of 1 character and maximum of 57 characters.
            const regexp = RegExp(/^[a-zA-Z0-9_-\s]{1,57}$/gi);
            const isValid = regexp.test(this.groupText);
            if (!isValid) {
                this.errorMessage = ErrorMessage.Invalid;
                this.invalidGroupText = true;
            }
            return isValid;
        };
        this.handleGroupAdd = async () => {
            this.loading = true;
            const canAddGroupName = this.canAddGroupName();
            // Add group if everything checks out OK
            try {
                if (canAddGroupName) {
                    await store_1.inventoryListStore.createInventoryGroup(this.groupText);
                    this.orderBy = "priority";
                    this.resetGroupText();
                    await this.loadInventories();
                    await store_1.inventoryListStore.loadInventoryGroup();
                }
            }
            catch (err) {
                console.error("Error in adding new inventory group", err);
            }
            finally {
                this.loading = false;
            }
        };
        this.handleGroupSave = async () => {
            const regexp = RegExp(/^[a-zA-Z0-9_-\s]{1,57}$/gi);
            const validString = regexp.test(this.groupTextEditing);
            if (validString) {
                await store_1.inventoryListStore.saveInventoryGroup(this.groupTextEditing, this.rowToEdit);
                this.orderBy = "priority";
                await store_1.inventoryListStore.loadInventoryGroup();
                await this.loadInventories();
            }
            else {
                this.errorMessage = ErrorMessage.Invalid;
                this.invalidGroupText = true;
            }
            this.showGroupEditModal = false;
        };
        this.handleGroupFieldChange = (event, value) => {
            this.invalidGroupText = false;
            this.groupText = value.toUpperCase();
        };
        this.handleGroupManagementToggle = async () => {
            if (!this.manageGroupMode) {
                await this.onRequestSortPriority("priority");
                this.orderBy = "priority";
                this.loadInventories();
            }
            this.manageGroupMode = !this.manageGroupMode;
        };
        // E-003 TMPP > Formulary - Option to Hide Unchecked NDC's
        this.handleShowDisabledNDCs = async () => {
            this.manageDisabledNDC = !this.manageDisabledNDC;
        };
        // C-046.11
        this.handleNonSelectedNDCs = async () => {
            this.manageDisabledNDC = !this.manageDisabledNDC;
        };
        this.handleGroupTextFieldOnBlur = () => {
            this.invalidGroupText = false;
        };
        /**
         * Render the master formulary list
         */
        this.renderGroupedList = () => {
            /**
             * @name updateToPharm
             * @description Parse the inventory based on priority overrides if the user
             *    selects a pharmacy other than the master.
             * @param value The current inventory.
             * @returns The updated inventory.
             */
            const updateToPharm = (value) => value.map((row) => {
                if (row.children.length > 0) {
                    const items = row.children;
                    const firstItem = items[0].sites;
                    const hasItem = firstItem.length > 0 &&
                        firstItem.find((site) => {
                            if (site.siteId === this.siteId)
                                return site;
                        });
                    if (hasItem && hasItem.priorityOverride) {
                        items.forEach((item) => {
                            const sites = item.sites;
                            const activeSiteSettings = sites &&
                                sites.find((site) => {
                                    if (site.siteId === this.siteId)
                                        return site;
                                });
                            const replacement = activeSiteSettings && activeSiteSettings.priorityOverride;
                            item.priorityOverride = replacement || 0;
                        });
                    }
                }
                return row;
            });
            let { inventory: { value = [] } } = store_1.inventoryListStore;
            let groupListFromDB = store_1.inventoryListStore.inventoryGroups.value || [];
            // Filter to ensure no duplicate group name will be rendered to the master formulary list.
            groupListFromDB = groupListFromDB.filter((group) => !value.some(inventory => inventory.group === group.group));
            groupListFromDB = groupListFromDB.map((group) => {
                const children = [];
                return {
                    group: group.group,
                    children
                };
            });
            const notSetGroup = value.filter(child => child.group === "");
            const groupsWithName = value.filter(child => child.group !== "");
            value = groupListFromDB.concat(groupsWithName, notSetGroup);
            if (this.siteId) {
                value = updateToPharm(value);
            }
            return (React.createElement(ui_1.UiForm, { loading: this.loading },
                React.createElement(list_1.MaterialList, { checkbox: this.renderCheckAll(), columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderGroupedListRow, withMargin: true, wideHeader: true, resizableheader: true, customClass: "custom-material-list__formulary-list" })));
        };
        this.handleCheckGroup = async (row, checkedInv) => {
            const inventories = row.children;
            let invIds = inventories.map((inv) => inv.id);
            console.log(checkedInv, invIds);
            if (!!checkedInv.length && checkedInv.length !== invIds.length) {
                invIds = invIds.filter(id => !checkedInv.includes(id));
            }
            await this.handleToggleActive(invIds);
        };
        this.handleToggleActive = async (invIds) => {
            const invArr = Array.isArray(invIds) ? invIds : [invIds];
            const result = await store_1.inventoryListStore.updateInventorySiteActive(invArr, this.siteId);
            if (result.success) {
                await this.loadInventories();
            }
        };
        this.renderGroupedListRow = (row, index) => {
            let counter = 0;
            row.children.forEach(child => {
                const inventorysiteExistsAndAvailable = child.sites.some((inventorysite) => inventorysite.siteId === this.siteId && inventorysite.active === 1);
                if (inventorysiteExistsAndAvailable) {
                    ++counter;
                }
            });
            counter =
                this.siteId !== 0 ? counter : counter > 0 ? counter : row.children.length;
            const inventorysite = row.children.map(child => child.sites.find(invSite => invSite.siteId === this.siteId));
            const allChecked = !!inventorysite.length &&
                inventorysite.every((child) => !!child && child.active);
            const someChecked = !!inventorysite.length &&
                inventorysite.some((child) => !!child && child.active);
            const checkedInv = !!inventorysite.length &&
                inventorysite
                    .map((child) => !!child && child.inventoryId)
                    .filter(e => e);
            return (React.createElement("div", { key: index },
                React.createElement(list_item_1.MaterialListItem, { className: "tkay-group-header", category: list_item_1.IListItemCategory.GroupHeader, onClick: (event) => this.handleClickGroup(event, index) },
                    store_3.usersStore.permissions.UpdateInventory && (React.createElement(checkbox_1.MaterialCheckbox, { checked: allChecked, label: "", indeterminate: someChecked && !allChecked, onAction: () => this.handleCheckGroup(row, checkedInv) })),
                    React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` }),
                    React.createElement("span", null, `( ${counter} ) `)),
                React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                    React.createElement(list_1.MaterialList, { rows: row.children, renderRow: this.renderGroupedListChild }))));
        };
        this.renderGroupedListChild = (row, index) => {
            const { sites, priorityOverride, strengthDescription, name, generic, claimQuantity, dosage = "", price, id, priority: invPriority, package: invPkg, group } = row;
            const inventorysite = sites.find(invSite => invSite.siteId === this.siteId);
            const priority = priorityOverride ? priorityOverride : invPriority;
            if (inventorysite && inventorysite.active === 1) {
                this.inStock.push(id);
            }
            const inStock = this.siteId === 0 || (inventorysite && inventorysite.active === 1);
            const inventoryName = strengthDescription || name || generic + (!inStock ? " (No Supply)" : "");
            const stockClass = !inStock ? "out-of-stock-admin" : "";
            const quantity = !!inventorysite && inventorysite.claimQuantity
                ? inventorysite.claimQuantity.split(",").join("->")
                : claimQuantity.split(",").join("->");
            const toPath = inStock ? `/formulary/${this.siteId}/${row.id}` : "";
            return (store_3.usersStore.permissions.ReadAllFormulary || inStock) &&
                String(this.siteId) === "0" || (!this.manageDisabledNDC ? this.inStock.includes(id) : true) ? ( //C-046.11
            React.createElement(list_item_1.MaterialListItem, { key: index, onClick: event => {
                    if (event.target.type !== "checkbox") {
                        router_1.RouteManager.transitionTo(toPath);
                    }
                }, className: stockClass },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(React.Fragment, null,
                        React.createElement(checkbox_1.MaterialCheckbox, { checked: this.inStock.includes(id), label: "", onAction: () => this.handleToggleActive(id) }),
                        invPkg) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(dosage) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: quantity }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: group === ""
                        ? "N/A"
                        : priority !== 0 && this.getGetOrdinal(priority) }))) : null;
        };
        this.toggleConfirmGroupManagementSave = (action) => () => {
            switch (action) {
                case "show":
                    this.showConfirmationGroupManagementSave = true;
                    break;
                case "hide":
                default:
                    this.showConfirmationGroupManagementSave = false;
                    break;
            }
        };
        this.onRequestSortPriority = async (property) => {
            this.orderBy = property;
            this.order = "ASC";
            await this.loadInventories();
        };
        this.onRequestSort = async (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            await this.forceUpdate();
        };
        this.handleClickGroup = (event, index) => {
            if (event.target.type === "checkbox")
                return;
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false ? true : false
            });
        };
        this.updateSiteSelect = async (id) => {
            this.siteId = Number(id);
            this.inStock = [];
            store_1.inventoryListStore.currentActiveSiteSelected = Number(id);
            await this.loadInventories();
        };
        this.renderPharmSelect = () => {
            const sites = [...this.availableOptions] || [];
            store_3.usersStore.user.value &&
                store_3.usersStore.user.value.user || store_3.usersStore.permissions.ReadMaster ? // C-046.6
                sites.unshift({
                    id: 0,
                    label: "Master Formulary",
                    value: "0"
                }) : null;
            return (!this.manageGroupMode && (React.createElement("div", { className: "change-view" },
                store_3.usersStore.permissions.ReadPharmacies || store_3.usersStore.permissions.ReadMaster ? ( // C-046.6
                React.createElement(React.Fragment, null,
                    React.createElement(select_1.MaterialSelect, { label: "Currently Viewing", value: store_3.usersStore.user.value && store_3.usersStore.user.value.siteUser
                            ? store_3.usersStore.user.value.site.id.toString()
                            : String(this.siteId), options: sites, onSelect: this.updateSiteSelect, searchable: true }))) : null,
                store_3.usersStore.permissions.UpdateInventory && this.siteId !== 0 && (React.createElement(React.Fragment, null,
                    React.createElement(button_1.MaterialButton, { style: { height: "45px" }, primary: true, to: `/lots/pharmacies/${this.siteId}/inventory-lot`, disabled: this.siteId === 0 }, "Manage Inventory"))),
                React.createElement("div", { className: "add-group" },
                    React.createElement(core_1.ClickAwayListener, { onClickAway: this.handleClickAway },
                        React.createElement("div", { style: { margin: 10 } },
                            React.createElement(Button_1.default, { "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: this.handleClick },
                                React.createElement(material_ui_icons_1.MoreVert, null)),
                            React.createElement(material_ui_1.Menu, { id: "simple-menu", anchorEl: this.state.anchorEl, keepMounted: false, open: this.state.anchorEl },
                                String(this.siteId) !== "0" && (React.createElement(material_ui_1.MenuItem, { onClick: this.handleNonSelectedNDCs }, "Show Non Selected")),
                                String(this.siteId) === "0" && (React.createElement(material_ui_1.MenuItem, { onClick: this.showDisableNDC }, "Show Disabled")))))))));
        };
        this.state = {
            anchorEl: null
        };
    }
    get availableOptions() {
        const adminAndDEV = store_3.usersStore.user.value.groupId == 1 || store_3.usersStore.user.value.groupId == 4;
        if (adminAndDEV) {
            return store_2.sitesListStore.sites.value
                ? store_2.sitesListStore.sites.value.map((site, i) => ({
                    id: i,
                    label: site.displayName || site.name,
                    value: site.id.toString()
                }))
                : [];
        }
        else {
            const user = store_3.usersStore.user.value || null;
            // const showAllSites = usersStore.permissions.ReadPharmacies;
            const options = store_2.sitesListStore.sites.value.filter(site => site.id === user.site.id || user.sites.includes(site.id))
                .map((site, i) => ({
                id: i + 1,
                label: site.displayName || site.name,
                value: String(site.id)
            }));
            if (true) {
                options.unshift({
                    id: 0,
                    label: "All Pharmacy",
                    value: "0"
                });
            }
            return options;
        }
    }
    /**
     * Load the inventories and inventory groups before component mounts
     */
    async componentWillMount() {
        ReactTooltip.rebuild();
        const isTmp = store_3.usersStore.user.value && store_3.usersStore.user.value.user;
        const userSiteId = store_3.usersStore.user.value.site.id;
        const currentActiveSiteSelected = store_1.inventoryListStore.currentActiveSiteSelected !== null
            ? store_1.inventoryListStore.currentActiveSiteSelected
            : userSiteId;
        const activeSiteId = isTmp ? currentActiveSiteSelected : userSiteId;
        this.siteId = activeSiteId;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    async componentDidMount() {
        this.loading = true;
        await store_1.inventoryListStore.loadInventoryGroup();
        await this.loadInventories();
        await store_2.sitesListStore.loadSitesNoRelation();
        this.loading = false;
        ReactTooltip.rebuild();
    }
    componentWillUnmount() {
        ReactTooltip.hide();
    }
    renderCheckAll() {
        return (
        // <MaterialCheckbox
        //   onAction={this.handleCheckAll}
        //   label=""
        //   checked={this.checkedAll}
        //   indeterminate={this.indeterminate}
        // />
        React.createElement(checkbox_1.MaterialCheckbox, { className: "material-list__header-checkbox--hidden", onAction: () => console.info("No Action"), label: "", checked: false, indeterminate: false }));
    }
    render() {
        ReactTooltip.rebuild();
        return (React.createElement("div", { className: "inventory-list inventory-list--formulary-custom" }, store_3.usersStore.permissions.ReadFormulary ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory-list__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Formulary" }),
                    store_3.usersStore.permissions.CreateFormulary && (React.createElement("div", { className: "floating-buttons", tabIndex: 0 },
                        React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "srch-inventory-btn", to: "/formulary/search" },
                            React.createElement(Search_1.default, null)),
                        React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-inventory-btn", to: "/formulary/new" },
                            React.createElement(Add_1.default, null)))))),
            React.createElement(floating_page_1.FloatingPage, null, React.createElement("div", { className: "inventory-list__content" },
                !this.manageGroupMode && (React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Formulary", callBack: this.onCallback, filterText: this.filterText })),
                React.createElement("div", { className: "group-management-container" },
                    React.createElement("div", { className: "add-group" },
                        store_3.usersStore.permissions.ReadMaster && (React.createElement("div", { className: "add-group__right" }, this.siteId === 0 ? (React.createElement(switch_1.MaterialSwitch, { label: "Manage Groups", value: this.manageGroupMode.toString(), onChange: this.handleGroupManagementToggle, checked: this.manageGroupMode, disabled: this.siteId !== 0 })) : null)),
                        this.manageGroupMode && (React.createElement("div", { className: "add-group__left" },
                            React.createElement("div", { className: "add-group__left--alert" }, this.invalidGroupText && (React.createElement(alert_1.UiAlert, { message: this.errorMessage }))),
                            React.createElement("div", { className: "add-group__left--input" },
                                React.createElement(text_field_1.MaterialTextFieldGroupText, { className: "group", label: "Group", error: this.invalidGroupText, onChange: this.handleGroupFieldChange, onBlur: this.handleGroupTextFieldOnBlur, value: this.groupText || "", onAddGroup: this.handleGroupAdd }),
                                React.createElement(Button_1.default, { className: "add-group-button", color: "primary", variant: "raised", onClick: this.handleGroupAdd, disabled: this.loading }, "Add group"),
                                React.createElement(Button_1.default, { className: "add-group-button", color: "primary", variant: "raised", onClick: this.toggleConfirmGroupManagementSave("show"), disabled: this.loading }, "save")))),
                        this.renderPharmSelect())),
                this.manageGroupMode ? (React.createElement(manage_group_1.InventoryManageGroup, { loadInventories: this.loadInventoriesPriorityAscending, loading: store_1.inventoryListStore.inventory.loading, onRequestSort: this.onRequestSort, handleGroupManagementToggle: this.handleGroupManagementToggle, showConfirmationGroupManagementSave: this.showConfirmationGroupManagementSave, toggleConfirmGroupManagementSave: this.toggleConfirmGroupManagementSave })) : (this.renderGroupedList()))))) : (store_3.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.computed
], InventoryList.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "checkedParents", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "confirmDelete", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "groupText", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "groupToBeRemoved", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "manageGroupMode", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "manageDisabledNDC", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "invalidGroupText", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "showGroupEditModal", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "rowToEdit", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "groupTitleEditMode", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "groupTextEditing", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "editqty2run", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "editqty2runId", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "newQuantityToRun", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "showGroupRemoveConfirmation", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "showConfirmationGroupManagementSave", void 0);
__decorate([
    mobx_1.observable
], InventoryList.prototype, "siteId", void 0);
InventoryList = __decorate([
    mobx_react_1.observer
], InventoryList);
exports.InventoryList = InventoryList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-list/inventory-list.tsx
// module id = 3495
// module chunks = 0